import React from 'react';
import style from './style.module.css'

import Icons from '../Icons/Icons';
import { faSquareCheck, faSquareXmark, faVideo, faBook, faUser, faQuestion, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

interface PartItemProps {
    content: string,
    date: string,
    indicator: string,
    points?: number
}

const ActivityItem: React.FC<PartItemProps> = ({content, date, indicator, points}) => {

    const goodLabel = 'good';
    const badLabel = 'bad';
    const chapterLabel = 'chapter';
    const videoLabel = 'video';
    const quizLabel = 'quiz';

    let icon;
    let styleSet;

    switch (indicator) {
        case goodLabel:
            icon = <Icons icon={faSquareCheck} />;
            styleSet = style.good;
            break;
        case badLabel:
            icon = <Icons icon={faSquareXmark} />;
            styleSet = style.bad;
            break;
        case chapterLabel:
            icon = <Icons icon={faBook} />;
            styleSet = style.book;
            break;
        case videoLabel:
            icon = <Icons icon={faVideo} />;
            styleSet = style.video;
            break;
        case quizLabel:
            icon = <Icons icon={faQuestionCircle} />
            styleSet = style.quiz;
            break;
        default:
            icon = <Icons icon={faUser} />;
            styleSet = style.default;
    }

    return (<>
        <div className={style.activityLine}>
            <div className={`${style.indicator} ${styleSet}`}>{icon}</div><div className={style.label}>
                {content} {
                    points ?
                        <span>{'(+' + points + ')'}</span> : ''
                }
            </div><div className={style.date}>
                {date}
            </div>
        </div>
    </>)
}

export default ActivityItem;